<template>
  <div class="component-content sub-content">
    <!-- <div class="tip">* 维修/新购出库登记仅限在二级仓库使用</div> -->
    <div class="list-title">
      <div class="r">
        <router-link :to="'/Storage/MaterialOut/'+houseId">
          <el-button type="primary" size="mini">维修/新购出库登记</el-button>
        </router-link>
        <!-- 
        <el-button type="primary" @click="EditStorageRoom('create')" size="mini">出库申请</el-button> -->
      </div>

      <label class="label-name">当前仓库：</label>
      <el-select size="small" class="organization-select" v-model="houseId" placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;">条件搜索<span class="tip"
          style="font-size:12px;">（搜索条件为选填, 然后点击搜索按钮进行搜索）</span></h3>
      <section>
        <label class="label-name">单号：</label>
        <el-input v-model="filter.number" size="small" placeholder="单号(模糊搜索)" style="width:140px;"></el-input>

        <label class="label-name" style="margin-left:15px;">材料名称：</label>
        <el-input v-model="filter.materialName" placeholder="材料名称关键字(模糊搜索)" size="small" style="width:230px;">
        </el-input>

        <label class="label-name" style="margin-left:15px;">出库类型：</label>
        <el-select size="small" v-model="filter.type">
          <el-option v-for="item,i in typeArr" :key="i" :value="item" :label="item"></el-option>
        </el-select>
      </section>
      <section style="margin-top:5px;">
        <div class="r">
          <a :href="baseURL+'/storage/material/out/order/list/download?depId='+this.depId+'&houseId='+this.houseId+'&startTime='+this.filter.startTime+'&endTime='+this.filter.endTime+'&materialName='+this.filter.materialName+'&number='+this.filter.number+'&type='+this.filter.type+'&user='+this.filter.createName"
            style="float:right;position:relative;z-index:2;" target="_blank">
            <el-button type="primary" size="mini">维修/新购出库登记表下载</el-button>
          </a>
        </div>

        <label class="label-name">领用人：</label>
        <el-input v-model="filter.createName" placeholder="领用人(模糊搜索)" size="small" style="width:230px;"></el-input>
        <label class="label-name" style="margin-left:15px;">时间：</label>

        <el-date-picker v-model="filter.startTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          style="width:180px!important;" placeholder="开始时间"></el-date-picker><span
          style="width:30px;display:inline-block;text-align:center">至</span>
        <el-date-picker v-model="filter.endTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          style="width:180px!important;" placeholder="结束时间"></el-date-picker>
        <el-button type="success" @click="getLists()" size="mini">搜索</el-button>
      </section>
    </div>

    <div class="table-total">
      <span>材料领用合计数量：{{ total.sl }} 件</span>
      <span>总金额：{{ total.zj }} 元</span>
    </div>
    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="number" label="维修/领用单号" width="100" align="center">
      </el-table-column>
      <el-table-column prop="house.name" width="140px" label="所属仓库">
      </el-table-column>
      <el-table-column prop="type" label="出库类型" width="80px" align="center">
      </el-table-column>
      <el-table-column label="出库单材料">
        <template slot-scope="scope">
          <span v-html="getOutMaterials(scope.row)"></span>
        </template>
      </el-table-column>
      <el-table-column label="领用人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.user'></user-info>
        </template>
      </el-table-column>
      <!-- <el-table-column label="出库管理员" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column> -->
      <el-table-column prop="outTime" label="出库时间" width="140px">
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialOutDetail(scope.row)" type="primary">详情</el-button>
          <!-- <el-button plain size="mini" @click="ShowMaterialInEdit(scope.row)" type="success">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>


    <el-pagination v-if="pageTotal>filter.pageSize" class="list-pagination" background :page-size="filter.pageSize"
      :pager-count="9" :current-page="filter.page+1" layout="pager" :total="pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>
    <!--     

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination> -->

    <material-out-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus" :materialOutData="materialOutData">
    </material-out-detail>

  </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import MaterialOutDetail from '@/page/storage/components/materialOutDetail'
  export default {
    components: {
      UserInfo,
      MaterialOutDetail,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,
        typeArr: ['维修', '新购', '药剂'],

        // 编辑出库单
        editMaterialInStatus: false,
        form: {
          inId: '',
          inVoice: '',
          supplierId: '',
        },
        supplierList: '',
        // 出库单明细详情
        detailStatus: false,
        materialOutData: "",

        filter: {
          createName: '',
          materialName: '',
          type: '',
          number: '',
          startTime: '',
          endTime: '',
          page: 0,
          pageSize: 20,
        },
        houseId: "",
        depId: "",
        houseList: "",

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageTotal: 0,
        listData: [],
        filterData: [],
        paginationData: [],

        // 合计
        total: {},
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.houseId = this.$route.params.houseId / 1
      }
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // 获取仓库列表
      this.getHouseList()

      // 获取供应商列表
      ajax.get('/supplier/list', {
        'type': 1
      }, (res) => {
        this.loading = false
        this.supplierList = res.vo.array
      })
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      // 组装出库单材料
      getOutMaterials(row) {
        let _m = []
        for (var i = 0; i < row.materials.length; i++) {
          let _item = row.materials[i]
          _m.push(_item.name + '（' + _item.amount + _item.unitName + '）')
        }
        return _m.join(",")
      },
      // 隐藏详情
      hideDetail() {
        this.detailStatus = false
      },
      // 显示出库单详情
      ShowMaterialOutDetail(row) {
        this.materialOutData = row
        this.detailStatus = true
      },
      // 获取仓库列表
      getHouseList() {
        // 只能看到拥有权限的仓库
        this.houseList = [{
          id: 0,
          name: this.userData.department.split("/")[0]
        }]
        this.houseList = this.houseList.concat(this.managerStorage)

        if (!this.houseId && this.houseList.length > 0) {
          this.houseId = this.houseList[0].id
        }

        this.getLists()
      },
      // 当前页
      handleCurrentChange(val) {
        this.filter.page = val - 1
        this.getLists()
      },
      // 分页筛选数据
      getPaginationData() {
        this.paginationData = this.filterData
      },
      // 获取列表
      getLists() {
        this.loading = true

        this.filter.houseId = this.houseId == 0 ? '' : this.houseId
        this.filter.depId = this.depId

        ajax.post('/storage/material/out/order/list', this.filter, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.list
          this.pageTotal = res.vo.size
          this.getPaginationData()

          this.total = {
            sl: res.vo.slAll,
            zj: res.vo.zjAll
          }
          // this.filterData = this.listData = res.vo.array
        })
      },
    },
    watch: {
      "houseId"() {
        this.getLists()
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/storage/materialOutList.vue